import Vue from 'vue';
import gsap from 'gsap';

const TweeningNumber = Vue.component('TweeningNumber', {
  props: {
    value: {
      type: Number,
      required: true,
    },
    gsapOptions: {
      type: Object,
      required: false,
    },
    asInteger: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return { tweeningValue: 0 };
  },
  created() {
    this.tweeningValue = this.value;
  },
  watch: {
    value(newVal: number) {
      gsap.to(this.$data, {
        duration: 0.3,
        ...this.gsapOptions,
        tweeningValue: newVal,
      });
    },
  },
  render(createElement) {
    const slot = this.$scopedSlots.default;
    if (slot !== undefined) {
      return slot(this.$data.tweeningValue)![0];
    }
    return createElement('span', this.asInteger ? this.$data.tweeningValue.toFixed(0) : this.$data.tweeningValue);
  },
});

export default TweeningNumber;
